// src/store/upcomingSession/upcomingSessionThunk.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getUpcomingSessionsAPI,
  getSessionByIdAPI,
  createSessionAPI,
  updateSessionAPI,
  deleteSessionAPI
} from './upcomingSessionAPI';

// Fetch all upcoming sessions
export const fetchUpcomingSessions = createAsyncThunk(
  'upcomingSession/fetchAll',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await getUpcomingSessionsAPI(params);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.message || 'Failed to fetch upcoming sessions'
      );
    }
  }
);

// Fetch session by ID
export const fetchSessionById = createAsyncThunk(
  'upcomingSession/fetchById',
  async (sessionId, { rejectWithValue }) => {
    try {
      const response = await getSessionByIdAPI(sessionId);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.message || 'Failed to fetch session'
      );
    }
  }
);

// Create new session
export const createSession = createAsyncThunk(
  'upcomingSession/create',
  async (sessionData, { rejectWithValue }) => {
    try {
      const response = await createSessionAPI(sessionData);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.message || 'Failed to create session'
      );
    }
  }
);

// Update session
export const updateSession = createAsyncThunk(
  'upcomingSession/update',
  async ({ sessionId, updateData }, { rejectWithValue }) => {
    try {
      const response = await updateSessionAPI(sessionId, updateData);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.message || 'Failed to update session'
      );
    }
  }
);

// Delete session
export const deleteSession = createAsyncThunk(
  'upcomingSession/delete',
  async (sessionId, { rejectWithValue }) => {
    try {
      const response = await deleteSessionAPI(sessionId);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.message || 'Failed to delete session'
      );
    }
  }
);